
require('prelude');

const Symbol = require('core-js/es6/symbol');
const Set = require('core-js/es6/set');

const _ = require('lodash');
import ko from 'rgs-knockout';


const _options = Symbol('_options');
const _set = Symbol('_set');
const _state = Symbol('_state');
const _isInBatchMode = Symbol('_isInBatchMode');


module.exports = class ObservableSet {
	constructor (options) {
		options = _.extend({}, {
			hash: _.identity,
		}, options);

		this[_options] = options;

		this[_set] = new Set;

		this[_state] = ko.observable(0);

		this[_isInBatchMode] = false;
	}

	_notify () {
		if (!this[_isInBatchMode]) {
			this[_state](this[_state]() + 1);
		}
	}

	has (k){
		this[_state]();
		return this[_set].has(this[_options].hash(k));
	}

	add (k){
		this[_set].add(this[_options].hash(k));
		this._notify();
	}

	delete (k){
		this[_set].delete(this[_options].hash(k));
		this._notify();
	}

	addAbsent (k) {
		if (!this.has(k)) {
			this.add(k);
		}
	}

	each (callback) {
		this[_state]();
		this[_set].forEach(callback);
	}

	values () {
		this[_state]();
		return Array.from(this[_set].values());
	}

	keys () {
		return this.values();
	}

	clear () {
		this[_set] = new Set;
		this.notify();
	}

	batch (operation) {
		if (this[_isInBatchMode]) {
			// nested `batch` calls
			operation();
			return;
		}
		this[_isInBatchMode] = true;
		try {
			operation();
		} finally {
			this[_isInBatchMode] = false;
		}
		this._notify();
	}
};

